import { useCallback } from 'react';

import { getPaymentProcessor } from 'components/UserPaymentForm/utils';
import { useGetUserQuery } from 'store/api/version-api.slice';

const useGetCurrentUserPaymentProcessor = () => {
	const { data: userData = {} } = useGetUserQuery();

	const handler = useCallback(() => {
		return getPaymentProcessor(userData);
	}, [userData]);

	return handler;
};

export default useGetCurrentUserPaymentProcessor;
